import "./NursingServices.module.css";
import NavigationHeader from "@/reusable_sections/Header";
import AlliedHealthServices from "./sections/AlliedHealthServices";
import OnzeWerkwijze from "./sections/OnzeWerkwijze";
import GlobalPresence from "./sections/GlobalPresence";
import FooterInformation from "@/reusable_sections/Footer";
export default function NursingServicesPage() {
  return <div>
      <NavigationHeader />
      <AlliedHealthServices />
      <OnzeWerkwijze />
      <GlobalPresence />
      <FooterInformation />
    </div>;
}